import React from 'react';
import { useLocation } from 'react-router-dom';
import { useURLSecurity } from './utils/urlSecurityUtils';
import { createTheme, ThemeProvider } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import Button from '@mui/material/Button';

const theme = createTheme({
	palette: {
		primary: { main: "#99aab5" },
		secondary: { main: "#F27920" },
	},
});

const NotFoundPage = () => {
	const location = useLocation();
	const securityReport = useURLSecurity(location.pathname);

	React.useEffect(() => {
		if (securityReport?.severity === 'HIGH') {
			// You might want to take additional actions for high-severity threats
			console.warn('High severity security threat detected:', securityReport);
		}
	}, [securityReport]);



	return (
		<div className='bg-white p-20'>


			<section className=''>
				<article className='lg:flex lg:gap-5'>
					<section className='lg:w-3/12'>
						<h2
							className='text-9xl font-bold text-center text-[#F27920]'

							aria-label='Error code: 404'
						>
							404
						</h2>
					</section>

					<section className='lg:w-9/12'>
						<div className="p-6 max-w-lg mx-auto">
							<h1 className="text-2xl font-bold mb-4">
								{securityReport?.severity === 'HIGH'
									? 'Access Denied'
									: 'Page Not Found'}
							</h1>
							<p className="mb-4">
								{securityReport?.severity === 'HIGH'
									? "This request has been blocked for security reasons."
									: "The page you're looking for doesn't exist. Please check the URL and try again."}
							</p>
						</div>

						<div className='lg:w-6/12 mx-auto'>
							<ThemeProvider theme={theme}>
								<Button
									fullWidth
									variant="contained"
									color="secondary"
									size='large'
									aria-label='Go back to home page'
									title="Go back to the home page"
									href='/'
									style={{ color: 'white' }}
								>
									<HomeIcon />&nbsp;&nbsp;<b>Go Back to Home</b>
								</Button>
							</ThemeProvider>
						</div>
					</section>
				</article>

			</section>





		</div>
	);
};

export default NotFoundPage;
